import { FetchRest } from "@config/httpClient";

interface ExportProductToStoreProps extends ServiceProps {
  interfaceLang: string;
  productId: string;
};

interface ServiceProps {
  userId: string;
  storeId: string;
  language: string;
};

export const updatedExportedProductToStore = async (props: ExportProductToStoreProps) => {

  const { interfaceLang, productId, ...serviceProps } = props;

  const uri = `/shopify/update_product/${productId}`;
  const response = await FetchRest<ServiceProps>({
    uri,
    method: 'PUT',
    requireAuth: true,
    body: serviceProps
  });

  if (response.error) {
    const message = response.messages[interfaceLang];
    throw new Error(message);
  }

  return response.data;

};